import { render } from "./MyInQuriy.vue?vue&type=template&id=29212f96"
import script from "./MyInQuriy.vue?vue&type=script&lang=js"
export * from "./MyInQuriy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__